module.exports = __webpack_public_path__ + "img/nt15-20-75-1.prt.8abb4207.jpg";